/* eslint-disable max-classes-per-file */
/* eslint-disable func-names */
/* eslint-disable no-var */
/* eslint-disable no-extend-native */
// #=#=#=#=#=#=#=#=# 扩展常用对象/垫片 #=#=#=#=#=#=#=#=#

/**
 * 格式化日期对象为指定格式的字符串。
 *
 * 默认格式为 'yyyy-MM-dd'，但可以通过传递不同的格式字符串来改变。支持的格式字符串包括：
 * yy - 两位数的年份
 * yyyy - 四位数的年份
 * M - 月份
 * MM - 两位数的月份
 * d - 日期
 * dd - 两位数的日期
 * h - 小时
 * hh - 两位数的小时
 * m - 分钟
 * mm - 两位数的分钟
 * s - 秒数
 * ss - 两位数的秒数
 * fff - 毫秒数
 * aa - 上午/下午
 * ww - 星期
 * zz - 时区
 *
 * @param {string} [format='yyyy-MM-dd'] - 定义输出日期字符串格式的模板。
 * @param {number} [options.offset] - 时区偏移量（分钟）。默认为日期对象的时区偏移量。
 * @param {string[]} [options.weeks] - 星期几的名称数组。默认为 ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']。
 * @param {string[]} [options.ampm] - 上午和下午的名称数组。默认为 ['AM', 'PM']。
 * @returns {string} 格式化后的日期字符串。
 */
Date.prototype.format = function(format = 'yyyy-MM-dd', options = {}) {
  const {
    weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    ampm = ['AM', 'PM'],
  } = options;

  // 提前获取年、月、日等可能多次使用的值
  const year = this.getFullYear();
  const month = this.getMonth() + 1;
  const day = this.getDate();
  const hours = this.getHours();
  const minutes = this.getMinutes();
  const seconds = this.getSeconds();
  const offset = this.getTimezoneOffset();

  // 辅助函数，用于格式化数字为指定长度的字符串
  const pad = (num, len) => num.toString().padStart(len, '0');

  // 替换格式字符串中的占位符
  return format.replace(/y{2,4}|\bm\b|mm|\bd\b|dd|\bh\b|hh|\bs\b|ss|fff|aa|ww|zz/ig, (match) => {
    switch (match) {
      case 'yy': return year.toString().substr(2);
      case 'yyyy': return year;
      case 'M': return month;
      case 'MM': return pad(month, 2);
      case 'd': return day;
      case 'dd': return pad(day, 2);
      case 'h':
      case 'hh':
        return format.includes('aa') ? pad(hours % 12 || 12, match.length) : pad(hours, match.length);
      case 'm': return minutes;
      case 'mm': return pad(minutes, 2);
      case 's': return seconds;
      case 'ss': return pad(seconds, 2);
      case 'fff': return pad(this.getMilliseconds(), 3);
      case 'aa': return ampm[hours < 12 ? 0 : 1];
      case 'ww': return weeks[this.getDay()];
      case 'zz': return `${offset > 0 ? '-' : '+'}${pad(Math.floor(Math.abs(offset) / 60), 2)}:${pad(Math.abs(offset) % 60, 2)}`;
      default: return match;
    }
  });
};

/**
 * 将当前时区的时间转至特定时区的时间，返回新的Date对象。
 * @param {*} offset 时间偏移，单位分数
 */
Date.prototype.toOffsetDate = function(offset = null) {
  if (offset === null) {
    offset = this.getTimezoneOffset();
  } else if (typeof offset === 'string') {
    const matchs = /([+-]\d{2}):?(\d{2})/.exec(offset);
    offset = parseInt(matchs[1], 10) * -60 + parseInt(matchs[2], 10);
  }

  const offsetDate = new Date(this.getTime() + (this.getTimezoneOffset() - offset) * 60 * 1000);
  offsetDate.getTimezoneOffset = () => offset;
  return offsetDate;
};

/**
 * 反解析日期
 */
Date.from = function(val, defaultValue = null, offset = null) {
  let parsedVal = null;

  // 如果val已经是Date对象，直接使用
  if (val instanceof Date && String(val) !== 'Invalid Date') {
    parsedVal = val;
  } else if (typeof val === 'string') { // 如果val是字符串，尝试解析
    // 尝试解析原字符串
    parsedVal = Date.parse(val);
    // 如果解析失败，尝试替换常见分隔符后再次解析
    if (Number.isNaN(parsedVal)) {
      parsedVal = Date.parse(val.replace(/[-._]/g, '/'));
    }
    // 如果解析结果仍然不是数字，且val只包含数字，尝试将其作为时间戳处理
    if (Number.isNaN(parsedVal) && /^\d+$/.test(val)) {
      parsedVal = parseInt(val, 10);
    }
    // 如果最终解析结果仍然不是数字，返回默认值
    if (Number.isNaN(parsedVal)) {
      return defaultValue;
    }
    parsedVal = new Date(parsedVal);
  } else { // 如果val不是字符串或Date对象，尝试直接作为Date构造函数的参数
    parsedVal = new Date(val);
  }

  // 如果parsedVal是无效日期，返回默认值
  if (String(parsedVal) === 'Invalid Date') {
    return defaultValue;
  }

  // 应用时区偏移
  if (offset !== null) {
    if (typeof offset === 'string') {
      const matchs = /([+-]\d{2}):?(\d{2})/.exec(offset);
      offset = parseInt(matchs[1], 10) * -60 + parseInt(matchs[2], 10);
    }
    parsedVal.setMinutes(parsedVal.getMinutes() + offset - parsedVal.getTimezoneOffset());
  }

  return parsedVal;
};

/**
* 日期增加/减少一定时间
* unit: 'FullYear','Month','Date','Hours','Minutes','Seconds','MilliSeconds'
* @param {Number} num
* @param {string} unit
*/
Date.prototype.dateAdd = function(num, unit = 'Date') {
  if (typeof num === 'string') {
    num = parseInt(num, 10);
  }

  const newDate = new Date(this);
  newDate[`set${unit}`](this[`get${unit}`]() + num);
  return newDate;
};

/**
 * 格式化字符串
 * 例子：'{name}=1 {value}=2'.format({name:'abc', value: 'def'})
 * @param {*} kwargs
 */
String.prototype.format = function(kwargs) {
  return this.replace(/\{(\w+)\}/g, (sub, args) => kwargs[args] ?? '');
};

/**
 * 数组增加删除指定元素的方法
 * @param {*} val
 */
Array.prototype.remove = function(val) {
  let idx = -1;
  if (typeof val === 'function') {
    idx = this.findIndex(val);
  } else {
    idx = this.indexOf(val);
  }
  while (idx > -1) {
    this.splice(idx, 1);
    idx = this.indexOf(val);
  }
};

/**
 * 清空数组
 */
Array.prototype.clear = function() {
  this.splice(0, this.length);
};

/**
 * 数组异步Map扩展
 * @param {Function} action 处理函数
 * @param {Integer} poolSize 协程数量
 * @param {Function} progressCallback 进度回调函数
 * @param {Number} sleepMS 协程执行完继续执行的延时毫秒数
 * @returns Promise (全部处理完成后resolve结果集合，不会reject)
 */
Array.prototype.asyncMap = function asyncMap(action = item => item, poolSize = 5, progressCallback = null, sleepMS = 0, thisArg = null) {
  return new Promise(resolve => {
    const results = [];
    let index = 0;

    // 定义协程执行函数
    const execute = () => {
      if (index < this.length) {
        const item = this[index];
        index += 1;
        Promise.resolve(action.call(thisArg, item)).then(result => {
          results.push(result);
        }).catch(result => {
          results.push(result);
        }).finally(() => {
          if (typeof progressCallback === 'function') progressCallback(results);
          if (results.length === this.length) {
            resolve(results);
          } else if (sleepMS) {
            setTimeout(execute, sleepMS);
          } else {
            execute();
          }
        });
      }
    };

    // 按池子大小启动多协程
    for (let i = 0; i < poolSize && i < this.length; i += 1) {
      execute();
    }
  });
};

/**
 * Polyfill of requestAnimationFrame
 */
if (!('requestAnimationFrame' in window)) {
  window.requestAnimationFrame = next => {
    window.setTimeout(next, 16);
  };
}

/**
 * Polyfill of window.location.origin
 */
if (!('origin' in window.location)) {
  window.location.origin = `${window.location.protocol}//${window.location.host}`;
}

/**
 * Polyfill of Promise.any
 */
if (!('any' in Promise)) {
  Promise.any = (promises = []) => new Promise((resolve, reject) => {
    const errors = [];
    promises.forEach(p => {
      Promise.resolve(p).then(resolve).catch(err => {
        errors.push(err);
        if (errors.length >= promises.length) {
          reject(errors);
        }
      });
    });
  });
}

// #=#=#=#=#=#=#=#=# 工具函数/类 #=#=#=#=#=#=#=#=#
/**
 * 判断对象是否为null、undefined、'null'、'undefined'
 */
export function isNullOrUndefined(obj) {
  return ['undefined', 'null'].includes(String(obj));
}

/**
 * 判断对象是否为“空”
 */
export function isNullOrEmpty(obj) {
  if (isNullOrUndefined(obj)) {
    return true;
  }
  if (typeof obj === 'number') {
    return Number.isNaN(obj);
  }
  if (typeof obj === 'string' || Array.isArray(obj)) {
    return !obj.length;
  }
  if (obj) {
    return !Reflect.ownKeys(obj).length;
  }
  return true;
}

/**
 * 尝试获取对象值，弱失败则返回默认值
 * 建议使用ES6的a?.b语法
 * @param {object|Array} obj 对象或数组
 * @param {string|Array} path 值路径
 * @param {any} defaultValue 默认值
 */
export function getProp(obj, path, defaultValue) {
  if (isNullOrUndefined(obj) || !path) {
    return defaultValue;
  }

  // 解析路径
  if (typeof path === 'string') {
    path = path.replace(/]/g, '').split(/[.[\]]/);
  }

  for (const key of path) {
    if (Array.isArray(obj)) {
      const idx = parseInt(key, 10);
      obj = obj[Number.isNaN(idx) ? key : idx];
    } else if (typeof obj === 'object' && key in obj) {
      obj = obj[key];
    } else {
      obj = null;
    }

    if (isNullOrUndefined(obj)) {
      return defaultValue;
    }
  }

  return obj;
}

/**
 * 抽样函数
 * 传入数字作为命中率的分母，如传入3，则表示三分之一命中，返回布尔值（是否抽中）
 */
export function sampling(num) {
  return parseInt(Math.random() * num, 10) === 0;
}

/**
 * 获取数据类型
 */
export function getType(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}

/**
 * 填充字符串至指定长度(尽量不要使用，建议使用ES6的padStart/padEnd)
 * @param {*} rawStr 待填充的字符串
 * @param {*} length 指定长度
 * @param {*} paddingStr 填充字符或字符串
 * @param {*} left 左填充还是右填充
 * @returns 填充后的新字符串
 */
export function stringPadding(rawStr, length, paddingStr = '0', left = true) {
  if (isNullOrUndefined(rawStr)) rawStr = '';
  if (typeof rawStr !== 'string') rawStr = String(rawStr);
  const need = length - rawStr.length;
  if (need <= 0) return rawStr;
  for (let i = 0; i < length; i += 1) {
    if (paddingStr.length > need) {
      paddingStr = paddingStr.slice(0, need);
      break;
    } else if (paddingStr.length === need) {
      break;
    } else {
      paddingStr += String(paddingStr);
    }
  }
  return left ? `${paddingStr}${rawStr}` : `${rawStr}${paddingStr}`;
}

/**
 * 重试函数，action返回非空则表示成功，否则继续重试
 * @param {int} times 最大重试次数
 * @param {int} delay 重试间隔毫秒
 * @param {function} action 重试的方法
 * @param {any} args 方法参数
 * @param {any} failback 回退方法
 */
export function retry(times, delay, action, arg, failback) {
  let i = 0;
  const excute = () => {
    i += 1;
    if (!action(arg, i)) {
      if (i <= times) {
        window.setTimeout(excute, delay);
      } else if (failback) {
        failback(arg);
      }
    }
  };
  excute();
}

/**
 * 将http开头的url变成https开头
 * @param {string} url
 */
export function httpsFix(url) {
  return url ? url.replace(/^http:/i, 'https:') : '';
}

/**
 * 防抖函数（返回包装后的函数，该函数将一段时间内多次动作触发仅保留最后一次）
 * @param {function} action  实际应用需要调用的函数
 * @param {number} delay  延迟时间，单位毫秒
 * @return {function} 返回的包装后的函数
 */
export function debounce(action, delay = 1e3) {
  let last = null;
  return function fn() {
    clearTimeout(last);
    last = setTimeout(() => {
      // eslint-disable-next-line prefer-rest-params
      action.apply(this, arguments);
    }, delay);
  };
}

/**
 * 稀释节流函数（返回包装后的函数，该函数确保每间隔delay内仅会执行一次action，多于一次的将丢弃）
 * @param {function} action 实际应用需要调用的函数
 * @param {number} delay 延迟时间，单位毫秒
 * @return {function} 返回的包装后的函数
 */
export function throttle(action, delay = 1e3) {
  let last = 0;
  return function fn() {
    const now = new Date().getTime();
    if (now - last > delay) {
      last = now;
      // eslint-disable-next-line prefer-rest-params
      action.apply(this, arguments);
    }
  };
}

/**
 * 平滑曲线计算
 * http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
 */
export function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}

/**
 * 平滑过渡函数easeInOut
 * @param {int} from 起始值
 * @param {int} to  结束值
 * @param {funtion} changeFn 补间动画执行函数
 * @param {int} duration 动画总时长（毫秒）
 */
export function smoothChange(from, to, changeFn, duration = 1000) {
  const start = new Date().getTime();
  const next = () => {
    const elapsed = new Date().getTime() - start;
    if (elapsed >= duration) {
      // 最后一次变化
      changeFn(to);
    } else {
      changeFn(elapsed > 0 ? from + (to - from) * easeInOutCubic(elapsed / duration) : from);
      window.requestAnimationFrame(next);
    }
  };
  next();
}

/**
 * 平滑置顶
 */
export function smoothScrollTop(duration = 500) {
  const from = window.pageYOffset
    || document.documentElement.scrollTop
    || document.body.scrollTop;
  smoothChange(from, 0, (y) => {
    window.scrollTo(0, y);
  }, duration);
}

/**
 * 将对象转为kvp字符串
 * 注意：
 * 1、会过滤undefined和null值
 * 2、会对对象值进行编码
 * @param {object} obj
 */
export function objectToKVP(obj) {
  if (!obj) {
    return '';
  }

  const kvp = [];
  for (const i in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, i) && !isNullOrUndefined(obj[i])) {
      kvp.push(`${i}=${encodeURIComponent(obj[i])}`);
    }
  }
  return kvp.join('&');
}

/**
 * 获取字符串hash值
 * @param {string} str
 */
export function getHashCode(str) {
  if (typeof str !== 'string') {
    str = String(str);
  }

  let hash = 1315423911;
  let ch = 0;
  for (let i = str.length - 1; i >= 0; i -= 1) {
    ch = str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash ^= ((hash << 5) + ch + (hash >> 2));
  }
  // eslint-disable-next-line no-bitwise
  return (hash & 0x7FFFFFFF);
}

/**
 * 获取字符串签名
 * @param {string} str
 */
export function getHashString(str) {
  return `${getHashCode(str).toString(36)}${str.length.toString(36)}`;
}

/**
 * 按字节剪裁字符串
 * @param {string} str 原串
 * @param {int} maxBytes 最大字节数
 * @param {string} ellipsis 省略符号
 */
export function ellipsisString(str, maxBytes, ellipsis = '...') {
  if (typeof str !== 'string') {
    str = isNullOrUndefined(str) ? '' : String(str);
  }

  let bytes = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    bytes += (str.charCodeAt(i) & 0xff00) === 0 ? 1 : 2;
    if (bytes > maxBytes) {
      return str.substr(0, i).concat(ellipsis);
    }
  }

  return str;
}

/**
 * 获取url中查询参数。可以指定参数name(数组或字符串)
 * 若不指定name，则解析获取所有参数为一个对象。
 * 若仅提供url参数部分，需要以?开头
 * @param {string} name
 * @param {string} url
 */
export function getQuery(name, url = window.location.href) {
  const val = nvp => (['undefined', 'null'].includes(String(nvp?.[1])) ? '' : decodeURIComponent(nvp[1]));
  url = url.split('?');
  let nvps = null;

  if (typeof name === 'string') {
    if (url.length < 2) {
      return null;
    }
    nvps = url[1].split('#')[0].split('&');
    for (let nvp of nvps) {
      nvp = nvp.split('=');
      if (nvp[0] === name) {
        return val(nvp);
      }
    }
    return null;
  }

  if (url.length < 2) {
    return {};
  }

  const query = {};
  nvps = url[1].split('#')[0].split('&');
  if (Array.isArray(name)) {
    for (let nvp of nvps) {
      nvp = nvp.split('=');
      if (name.includes(nvp[0])) {
        query[nvp[0]] = val(nvp);
      }
    }
  } else {
    for (let nvp of nvps) {
      nvp = nvp.split('=');
      query[nvp[0]] = val(nvp);
    }
  }
  return query;
}

/**
 * 设置或删除url的查询参数。args对象中的键对应值如果是null或undefined则删除之，否则添加或覆盖其值到url查询参数中
 * @param {object} args
 * @param {string} url
 */
export function setQuery(args, url = window.location.href, encode = true) {
  if (isNullOrEmpty(args)) return url;
  const query = getQuery(null, url);
  for (const key in args) {
    if (isNullOrUndefined(args[key])) {
      delete query[key];
    } else {
      query[key] = args[key];
    }
  }

  args = [];
  for (const key in query) {
    args.push(`${key}=${encode ? encodeURIComponent(query[key]) : query[key]}`);
  }

  let hash = url.split('#');
  hash = hash.length > 1 ? '#'.concat(hash[1]) : '';
  return `${url.split(/[?#]/)[0]}${args.length ? '?'.concat(args.join('&')) : ''}${hash}`;
}

/**
 * 删除url指定参数，返回删除的参数。不指定name则删除所有参数。
 * @param {string} name
 */
export function popQuery(name) {
  const query = getQuery(name);

  if (!name) {
    window.history.replaceState(window.history.state, null, window.location.href.split('?')[0]);
  } else {
    if (!Array.isArray(name)) {
      name = [name];
    }
    window.history.replaceState(window.history.state, null, setQuery(name.reduce((all, key) => {
      all[key] = null;
      return all;
    }, {})));
  }
  return query;
}

/**
 * 加载远程js后执行回调
 * @param {String} url
 * @param {Boolean} crossOrigin
 * @param {Number} timeout
 */
const LOADEDJS = {};
export function loadJS(url, timeout, crossOrigin = true, autoRemove = false) {
  // 检查是否已加载该js
  if (url in LOADEDJS) {
    return LOADEDJS[url];
  }

  LOADEDJS[url] = new Promise((resolve, reject) => {
    const el = document.createElement('script');
    if (crossOrigin) {
      el.crossOrigin = 'anonymous';
    }
    el.type = 'text/javascript';
    el.async = 'async';

    let timer = null;

    const cleanUp = isError => {
      if (timer) window.clearTimeout(timer);
      el.onload = null;
      el.onerror = null;
      if (autoRemove || isError) el.remove();
    };

    // 超时计时器
    if (timeout) {
      timer = window.setTimeout(() => {
        cleanUp(true);
        reject(new Error(`loadJS ${url} timeout ${timeout}ms`));
      }, timeout);
    }
    // 开始加载js
    el.onload = function onload() {
      cleanUp();
      resolve();
    };
    el.onerror = function onerror(err) {
      cleanUp(true);
      reject(err);
    };
    el.src = url;
    document.head.appendChild(el);
  });

  return LOADEDJS[url];
}

/**
 * 帮助元素加载src资源
 * @param {*} el 元素（img、video、audio等）
 * @param {*} loadUrl 资源地址
 * @param {*} timeout 超时时间
 * @param {*} fallbackUrl 回退资源地址（支持base64）
 * @returns Promise，无论成功失败都会resolve({el, error})
 */
export function loadSrc(el, loadURL, timeout, fallbackURL) {
  return new Promise((resolve) => {
    const res = { el, error: null };
    if (!el) {
      res.error = 'el empty';
      resolve(res);
      return;
    }

    let src = null;
    if (loadURL) {
      src = loadURL;
    } else {
      res.error = 'loadUrl empty';
      if (fallbackURL) {
        src = fallbackURL;
      } else {
        resolve(res);
      }
    }

    let timer = null;

    const cleanUp = () => {
      if (timer) window.clearTimeout(timer);
      el.onload = null;
      el.onerror = null;
    };

    // 超时计时器
    if (timeout) {
      timer = window.setTimeout(() => {
        if (fallbackURL && src !== fallbackURL) el.src = fallbackURL;
        res.error = `timeout ${timeout}ms`;
        resolve(res);
      }, timeout);
    }

    el.onload = function onload() {
      cleanUp();
      resolve(res);
    };
    el.onerror = function onerror(err) {
      cleanUp();
      if (fallbackURL && src !== fallbackURL) el.src = fallbackURL;
      res.error = err;
      resolve(res);
    };
    el.src = src;
  });
}

/**
 * 加载远程css
 * @param {string} url
 * @param {boolean} crossOrigin
 */
export function loadCss(url, crossOrigin) {
  // 已加载检查
  const nodes = document.head.childNodes;
  for (let j = 0; j < nodes.length; j += 1) {
    if (nodes[j] && nodes[j].rel === 'stylesheet' && nodes[j].href === url) {
      return;
    }
  }

  const el = document.createElement('link');
  el.type = 'text/css';
  el.rel = 'stylesheet';
  if (crossOrigin) {
    el.crossOrigin = 'anonymous';
  }
  el.href = url;
  document.head.appendChild(el);
}

/**
 * 合并对象（相比Object.assign函数，会做子对象递归合并）
 * @param target 目标对象，建议{}
 * @param source 要合入的对象
 */
export function mergeObject(target, ...source) {
  let sk = null;
  for (const s of source) {
    for (const k in s) {
      sk = s[k];
      if (Object.prototype.toString.call(sk) === '[object Object]') {
        if (!(k in target)) {
          target[k] = {};
        }
        if (Object.prototype.toString.call(target[k]) === '[object Object]') {
          mergeObject(target[k], sk);
        } else {
          target[k] = sk;
        }
      } else {
        target[k] = sk;
      }
    }
  }
  return target;
}

/**
 * 获取Cookie
 */
export function getCookie(name) {
  const cookies = document.cookie.split(';');
  let pairs = null;
  for (const cookie of cookies) {
    pairs = cookie.split('=');
    if (pairs.length > 1 && pairs[0].replace(' ', '') === name) {
      return decodeURIComponent(pairs[1]);
    }
  }
  return null;
}

/**
 * 设置Cookie
 */
export function setCookie(name, value, expires, path, domain, secure) {
  const parts = [];
  parts.push(`${name}=${encodeURIComponent(value)}`);
  if (expires instanceof Date) {
    parts.push(`expires=${expires.toUTCString()}`);
  } else if (typeof expires === 'number') {
    parts.push(`max-age=${expires}`);
  }
  if (path) {
    parts.push(`path=${path}`);
  }
  if (domain) {
    parts.push(`domain=${domain}`);
  }
  if (secure) {
    parts.push(`secure=${secure}; SameSite=None`);
  }
  document.cookie = parts.join('; ');
}

/**
 * 删除Cookie
 */
export function delCookie(name, path, domain) {
  if (getCookie(name) !== null) {
    const parts = [];
    parts.push(`${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT`);
    if (path) {
      parts.push(`path=${path}`);
    }
    if (domain) {
      parts.push(`domain=${domain}`);
    }
    document.cookie = parts.join('; ');
  }
}

/**
 * 设置sessionStorage
 */
export function setSS(name, value) {
  if (window.sessionStorage) {
    if (typeof value === 'object') {
      try {
        value = `_OBJECT_${JSON.stringify(value)}`;
      } catch (e) {
        value = String(value ?? '');
      }
    }
    window.sessionStorage.setItem(name, value);
  } else {
    if (!window.hobbitStorage) {
      window.hobbitStorage = {};
    }
    window.hobbitStorage[name] = value;
  }
}

/**
 * 获取sessionStorage
 */
export function getSS(name) {
  let result = null;
  if (window.sessionStorage) {
    const value = window.sessionStorage.getItem(name);
    if (value && value.substr(0, 8) === '_OBJECT_') {
      try {
        result = JSON.parse(value.substr(8));
      } catch (e) {
        result = value;
      }
    } else {
      result = value;
    }
  } else if (window.hobbitStorage) {
    result = window.hobbitStorage[name];
  }
  return result;
}

/**
 * 删除sessionStorage
 */
export function delSS(name) {
  if (window.sessionStorage) {
    window.sessionStorage.removeItem(name);
  } else if (window.hobbitStorage && name in window.hobbitStorage) {
    delete window.hobbitStorage[name];
  }
}

/**
 * 删除localStorage
 */
export function delLS(name) {
  if (window.localStorage) {
    window.localStorage.removeItem(name);
  } else if (window.hobbitStorage && name in window.hobbitStorage) {
    delete window.hobbitStorage[name];
  }
}

/**
 * 读取取localStorage
 */
export function getLS(name) {
  let item = null;
  if (window.localStorage) item = window.localStorage.getItem(name);
  else if (window.hobbitStorage) item = window.hobbitStorage[name];

  if (item && item[0] === '{') {
    try {
      item = JSON.parse(item);
      if (typeof item.t === 'number' && new Date() > new Date(item.t)) {
        // 删除过期数据
        delLS(name);
        return null;
      }
      return item.v;
    } catch (e) {
      console.warn(e);
    }
  }

  // 旧版兼容(去掉多余尾巴)
  if (typeof item === 'string') {
    const tailReg = /[@#]\d*$/;
    return item.replace(tailReg, '');
  }
  return item;
}

/**
 * 设置localStorage
 * 支持过期时间：expires可以使Date对象、毫秒时间戳数字或空(无限制)
 */
export function setLS(name, value, expires) {
  if (!name) return;
  const item = { v: value };
  if (expires instanceof Date) {
    item.t = expires.getTime();
  } else if (Number.isInteger(expires)) {
    item.t = expires;
  }
  if (window.localStorage) {
    window.localStorage.setItem(name, JSON.stringify(item));
    // 随机清理无效数据
    window.setTimeout(() => {
      const key = window.localStorage.key(Math.floor(Math.random() * window.localStorage.length));
      if (key) getLS(key);
      else window.localStorage.removeItem(key);
    }, 100);
  } else {
    if (!window.hobbitStorage) window.hobbitStorage = {};
    window.hobbitStorage[name] = value;
  }
}

/**
 * 获取主域(不含端口部分)
 */
export function getMainDomain(url = window.location.href) {
  let host = typeof url === 'string' ? url.split('/') : '';
  if (host && host.length > 2) {
    host = host[2].split(':')[0];
    if (/^(localhost|(\d+\.){3}\d+)$/i.test(host)) {
      return host;
    }
    return host.slice(window.location.hostname.indexOf('.')) || '';
  }
  return '';
}

/**
 * 获取UUID
 */
export function UUID() {
  const p1 = stringPadding(Math.random().toString(16).slice(-8), 8);
  const p234 = stringPadding(Math.random().toString(16).slice(-12), 12);
  const p5 = stringPadding(Math.random().toString(16).slice(-12), 12);
  return `${p1}-${p234.replace(/(?=(?!\b)(\w{4})+$)/g, '-')}-${p5}`.toUpperCase();
}

/**
 * 获取16位（36进制字符组成）唯一KEY（前8位按时间递增有序）
 */
export function UUKEY() {
  const p1 = stringPadding(new Date().getTime().toString(36).slice(-8), 8);
  const p2 = stringPadding(Math.random().toString(36).slice(-8), 8);
  return `${p1}${p2}`.toUpperCase();
}

// 极简事件订阅发布器
export class EventPublisher {
  constructor() {
    this.handlers = {};
  }

  /**
   * 订阅事件
   */
  on(name, handler) {
    if (!(name in this.handlers)) {
      this.handlers[name] = [];
    }
    this.handlers[name].push(handler);
  }

  /**
   * 触发事件
   */
  emit(name, ...handlerArgs) {
    if (this.handlers[name]) {
      for (const handler of this.handlers[name]) {
        handler.apply(this, handlerArgs);
      }
    }
  }

  /**
   * 删除订阅事件
   */
  off(name, handler) {
    const handlers = this.handlers[name];
    if (handlers) {
      for (let i = handlers.length - 1; i >= 0; i -= 1) {
        if (handlers[i] === handler) {
          handlers.splice(i, 1);
        }
      }
      if (handlers.length === 0) {
        delete this.handlers[name];
      }
    } else {
      delete this.handlers[name];
    }
  }
}

/**
 * 获取元素在网页文档中的位置
 */
export function getDomPosition(dom) {
  if (!dom) {
    return null;
  }

  const position = { x: 0, y: 0 };
  if ('getBoundingClientRect' in dom) {
    const domRect = dom.getBoundingClientRect();
    position.x = domRect.left
      + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft);
    position.y = domRect.top
      + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop);
  } else {
    let currentDom = dom;
    while (currentDom !== null) {
      position.x += currentDom.offsetLeft;
      position.y += currentDom.offsetTop;
      currentDom = currentDom.offsetParent;
    }
  }
  return position;
}

/**
 * 比较两个版本号大小。v1>v2返回1,v1<v2返回-1,相等返回0。若版本号格式无效返回null。
 * @param {string|number} v1 版本号1,由数字和点组成的版本号
 * @param {string|number} v2 版本号2,
 */
export function versionCompare(v1, v2) {
  const fmt = /^[\d.]+$/;
  if (!fmt.test(v1) || !fmt.test(v2)) {
    return null;
  }

  v1 = String(v1).split('.');
  v2 = String(v2).split('.');
  let n1; let n2;
  for (let i = 0; i < Math.max(v1.length, v2.length); i += 1) {
    n1 = i >= v1.length ? 0 : parseInt(v1[i], 10) || 0;
    n2 = i >= v2.length ? 0 : parseInt(v2[i], 10) || 0;
    if (n1 > n2) {
      return 1;
    }
    if (n1 < n2) {
      return -1;
    }
  }
  return 0;
}

/**
 * 打印控制台Banner信息
 */
export function consoleBanner(title, values, width, borderChar = '=', style = null) {
  if (!title) {
    title = new Date().format('yyyy-MM-dd hh:mm:ss');
  }
  if (!Number.isInteger(width)) {
    width = 30;
  }
  if (width <= title.length) {
    width = title.length + 10;
  }

  const helf = borderChar.repeat(Math.ceil((width - title.length - 2) / 2));
  const contents = [`${helf} ${title} ${helf}`];
  for (const key in values) {
    contents.push(`${key}: ${JSON.stringify(values[key])}`);
  }
  contents.push(`${borderChar.repeat(helf.length * 2 + title.length + 2)}`);
  const banner = contents.join('\n');
  if (style) {
    // eslint-disable-next-line no-console
    console.log(`%c${banner}`, style);
  } else {
    // eslint-disable-next-line no-console
    console.log(banner);
  }
  return banner;
}

/**
 * html编码
 */
export function htmlEncode(html) {
  if (!html) {
    return '';
  }
  return html.replace(/[<>]/g, c => ({
    '<': '&lt;',
    '>': '&gt;',
  })[c]);
}

/**
 * html解码
 */
export function htmlDecode(text) {
  return text.replace(/(&lt;)|(&gt;)/g, c => ({
    '&lt;': '<',
    '&gt;': '>',
  })[c]);
}

/**
 * 获取变量时间戳
 * @param {Number} interval
 */
export function timestamp(interval = 1000) {
  return parseInt(new Date().getTime() / (interval || 1), 10);
}

/**
 * 添加元素样式名
 */
export function addClassName(dom, classNames) {
  if (dom && typeof dom.className === 'string') {
    classNames = Array.isArray(classNames) ? classNames : [classNames];
    const classArray = dom.className.split(' ');
    for (const className of classNames) {
      if (!classArray.includes(className)) {
        classArray.push(className);
      }
    }
    dom.className = classArray.join(' ').trim();
  }
}

/**
 * 删除元素样式名
 */
export function removeClassName(dom, classNames) {
  if (dom && typeof dom.className === 'string') {
    classNames = Array.isArray(classNames) ? classNames : [classNames];
    const classArray = dom.className.split(' ');
    for (const className of classNames) {
      classArray.remove(className);
    }
    dom.className = classArray.join(' ').trim();
  }
}

/**
 * 极简定时器
 * API: start、stop、reset
 */
export class Timer {
  /**
   * 构造函数
   * @param {int} begin 起始时间
   * @param {int} end  结束时间
   * @param {funtion} onTick 间隔执行函数
   * @param {int} step 时间间隔步长
   */
  constructor(begin, end, onTick, step = 1e3) {
    this.begin = begin;
    this.end = end;
    this.step = step;
    this.onTick = onTick;

    this.$SetInterval = null;
    this.reset();
  }

  start() {
    this.$ClearInterval();
    if (this.$Current === this.begin) {
      this.onTick(this.begin);
    }
    this.$SetInterval = window.setInterval(this.$OnInterval.bind(this), this.step);
  }

  stop() {
    this.$ClearInterval();
  }

  reset() {
    this.$Current = this.begin;
  }

  $OnInterval() {
    const direction = this.end > this.begin ? 1 : -1;
    const next = this.$Current + direction * this.step;
    if (direction * next >= direction * this.end) {
      // 已经达到结束时间
      this.$Current = this.end;
      this.stop();
    } else {
      this.$Current = next;
    }
    this.onTick(this.$Current);
  }

  $ClearInterval() {
    if (this.$SetInterval) {
      window.clearInterval(this.$SetInterval);
    }
  }
}

/**
 * 带超时时间的Promise
 */
export class TimeoutPromise extends Promise {
  constructor(executor, timeout = 1e4) {
    let timer = null;
    const wrapperPromise = Promise.race([
      new Promise(executor),
      new Promise((resolve, reject) => {
        timer = window.setTimeout(() => {
          reject(new Error('timeout'));
        }, timeout);
      }),
    ]);

    super((resolve, reject) => {
      wrapperPromise.then((data) => {
        window.clearTimeout(timer);
        resolve(data);
      }).catch((error) => {
        window.clearTimeout(timer);
        reject(error);
      });
    });
  }
}

/**
 * 拷贝函数
 * @param {String} text 拷贝的内容
 */
export function copy(text) {
  const defaultCopy = () => {
    if (document.execCommand) {
      const element = document.createElement('textarea');
      element.style.position = 'fixed'; // 使用 fixed 定位
      element.style.left = '0px';
      element.style.top = '0px';
      element.style.opacity = '0'; // 隐藏元素;
      element.textContent = text;
      document.body.appendChild(element);
      element.select();
      element.setSelectionRange(0, element.value.length);
      const ret = document.execCommand('copy');
      if (element.remove) {
        element.remove();
      } else {
        element.removeNode(true);
      }
      if (ret) {
        return Promise.resolve(text);
      }
    }
    return Promise.reject();
  };

  if (window.clipboardData) {
    window.clipboardData.setData('text', text);
    return Promise.resolve(text);
  }
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).catch(defaultCopy);
  }
  return defaultCopy();
}

/**
 * 生成单例加载函数
 * @param {function} loadAction 加载函数
 * @param {boolean} allowRetryOnError 是否出错重试(默认true)
 * @returns 单例加载函数
 */
export function createLoaded(loadAction, allowRetryOnError = true) {
  const loadingPromise = {};

  return async function(...args) {
    const key = JSON.stringify(args);
    if (!(key in loadingPromise)) {
      loadingPromise[key] = Promise.resolve(loadAction(...args)).catch(error => {
        if (allowRetryOnError) {
          delete loadingPromise[key];
        }
        throw error;
      });
    }
    return loadingPromise[key];
  };
}

/**
 * 生成二维码图片工具方法
 * @param {*} options 选项：https://github.com/aralejs/qrcode
 */
let araleQRCodeLoaded = null;
export function createQRCode(options) {
  if (!araleQRCodeLoaded) {
    araleQRCodeLoaded = createLoaded(() => window.AraleQRCode ?? loadJS('//s.vipkidstatic.com/fe-static/hobbit/asset/lib/qrcode3.0.5.min.js', 1e4));
  }
  return araleQRCodeLoaded().then(() => new window.AraleQRCode(options));
}

/**
 * 获取元素路径
 * @param {*} node 元素节点
 * @param {Boolean} asc 父前子后，否则子前父后
 */
export function elementPath(node, asc = true) {
  if (!node || !('getAttribute' in node)) return String(node);
  const paths = [];
  while (node) {
    if (node.id) {
      paths.push(`#${node.id}`);
    } else if (node.className) {
      paths.push(`.${node.className.trim().replace(' ', '.')}`);
    } else {
      paths.push(String(node.nodeName).toLowerCase());
    }
    if (node.parentNode && !/body|head/i.test(node.parentNode.nodeName)) {
      node = node.parentNode;
    } else {
      break;
    }
  }
  return asc ? paths.reverse().join(',') : paths.join(',');
}

/**
 * 1像素空白透明图
 */
export const EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/**
 * 下载文件函数
 * @param {*} href 文件链接或base64数据
 * @param {*} name 下载文件名
 * @param {*} className 下载临时元素（a）的样式名
 */
export function handleDownload(href, name = 'download', className = '') {
  const el = document.createElement('a');
  el.href = href;
  if (className) el.className = className;
  el.style.display = 'none';
  el.download = name;
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
}

/**
 * 获取当前时区名
 */
export function getTimezoneName() {
  let timeZone = null;
  try {
    timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.warn(ex);
  }
  return timeZone;
}

/**
 * 返回12小时制度时间，且返回是否是PM
 * @param {Date} time
 */
export function get12HoursTime(val) {
  if (!val) return {};
  const time = new Date(val);
  if (String(time) === 'Invalid Date') return {};
  const hours = time.getHours();
  const isPM = hours >= 12;
  if (hours >= 13) {
    time.setHours(hours - 12);
  }
  return {
    time,
    isPM,
  };
}

/**
 * 通用正则常量
 */
export const REGEXS = {
  // eslint-disable-next-line max-len
  EMAIL: /^(([^<>()[\]\\.,;:+\s@"]+(\.[^<>()[\]\\.,;:+\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

/**
 * 默认base64字符串
 */
export const CUSTOM_BASE64 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_';
/**
 * 数字转换为指定进制(2~64)
 */
export function toBaseX(int, radix = 64, base = CUSTOM_BASE64) {
  const result = [];
  let y = 0;
  let sign = 0;
  if (int < 0) {
    int = -int;
    sign = 1;
  } else if (int === 0) {
    return '0';
  }
  while (int !== 0) {
    y = int % radix;
    int = Math.floor(int / radix);
    result.unshift(base[y]);
  }
  if (sign) result.unshift('-');
  return result.join('');
}

/**
 * 智能四舍五入到小数点第N位
 * @param {*} v 需要处理的数字
 * @param {*} defaultValue 默认值
 * @param {*} digits 小数部分位数
 */
export function smartFixed(v, defaultValue, digits = 2) {
  const num = parseFloat(v);
  if (Number.isNaN(num)) return defaultValue;
  return String(Math.round(num * 10 ** digits) / 10 ** digits);
}

/**
 * JSONP
 * @param {String} url
 * @param {String} cbParamName 回调参数名
 * @param {Number} timeout 超时毫秒数
 */
export function jsonp(url, cbParamName, timeout = 1e4) {
  const startTime = new Date().getTime();
  return new Promise(resolve => {
    const cbName = `jsonp${UUKEY()}`;
    const options = {
      url,
      cbParamName,
      timeout,
    };
    let timer = null;
    url = `${url}${url.indexOf('?') === -1 ? '?' : '&'}${cbParamName}=${cbName}`;
    window[cbName] = (...data) => {
      if (timer !== null) {
        clearTimeout(timer);
        resolve({
          options,
          data,
          errorCode: '',
          errorMessage: '',
          startTime,
          endTime: new Date().getTime(),
        });
      }
      delete window[cbName];
    };

    timer = setTimeout(() => {
      if (timer !== null) {
        timer = null;
        resolve({
          options,
          data: {},
          errorCode: 'TIMEOUT',
          errorMessage: 'timeout',
          startTime,
          endTime: new Date().getTime(),
        });
      }
    }, timeout);

    const el = document.createElement('script');
    el.type = 'text/javascript';
    el.onload = function onload() {
      this.onload = null;
      this.parentNode.removeChild(this);
    };
    el.onerror = function onerror(err) {
      resolve({
        options,
        data: {},
        errorCode: 'NETWORK_ERROR',
        errorMessage: String(err),
        startTime,
        endTime: new Date().getTime(),
      });
    };
    el.src = url;
    document.head.appendChild(el);
  });
}

/**
 * 模版字符串处理函数
 * @param {*} str 模版字符串
 * @param {*} defaultValue 默认值
 * @param {*} thisArg this对象
 * @returns 处理后的字符串
 */
export function templateStr(str, defaultValue = '', thisArg = null) {
  if (typeof str === 'string' && str) {
    return str.replace(/\$\{(.*?)\}/g, (match, expression) => {
      try {
        // eslint-disable-next-line no-new-func
        return Function(`return ${expression}`).call(thisArg);
      } catch (ex) {
        return defaultValue;
      }
    });
  }
  return str;
}

/**
 * 对象属性遍历修改
 * @param {*} obj 要遍历替换内容的对象
 * @param {*} replace 替换函数
 * @param {*} inplace 是否原地替换
 * @returns 替换后的新对象
 */
export function objectMap(obj, mapFunc, inplace = false) {
  switch (Object.prototype.toString.call(obj)) {
    case '[object Object]':
      // eslint-disable-next-line no-case-declarations
      const mapObj = inplace ? obj : {};
      for (const key in obj) {
        mapObj[key] = objectMap(obj[key], mapFunc, inplace);
      }
      return mapObj;
    case '[object Array]':
      // eslint-disable-next-line no-case-declarations
      const mapArr = inplace ? obj : [];
      for (let i = 0; i < obj.length; i += 1) {
        mapArr[i] = objectMap(obj[i], mapFunc, inplace);
      }
      return mapArr;
    default:
      return mapFunc(obj);
  }
}

/**
 * 等待多少毫秒继续执行
 * @param {*} delay 等待多少毫秒
 */
export function sleep(delay = 1e3) {
  return new Promise(resolve => {
    window.setTimeout(resolve, delay);
  });
}

/**
 * 检查一个数值是否包含特定的位标志[标志枚举]
 * @param {number} value 待检查的数值，一系列位标志的组合
 * @param {number} flag 特定的位标志
 * @return {boolean} 如果包含flag则返回true，反之false
 */
// eslint-disable-next-line no-bitwise
export const hasFlag = (value, flag) => (value & flag) === flag;
